import { takeLatest, put, all, race, take, delay } from 'redux-saga/effects';

import {
  actions as getPatientInsurancesListActions,
  consts as getPatientInsurancesListConsts,
} from '../requests/get-patient-insurances-list';
import {
  actions as getUserDocumentsActions,
  consts as getUserDocumentsConsts,
} from '../../profiles/get-user-documents';
import {
  actions as latestCheckInsuranceActions,
  consts as latestCheckInsuranceConsts,
} from '../../appointmentForm/requests/latest-check-insurance-req';

import {
  MANAGE_INSURANCES_ACTION_TYPES,
  manageInsurancesActions,
} from '../actions/manage-insurances-actions';

const TIMEOUT = 30000;

function* downloadPatientInsuranceDataWorker({ payload }) {
  yield put(manageInsurancesActions.setInsuranceRelatedDataFetching(true));

  const { userId } = payload;

  yield all([
    put(latestCheckInsuranceActions.send({ userId })),
    put(getUserDocumentsActions.send({ userId })),
  ]);

  const [latestInsuranceCheckData, patientDocuments] = yield all([
    race({
      success: take(latestCheckInsuranceConsts.SUCCEED),
      failure: take([
        latestCheckInsuranceConsts.REJECTED,
        latestCheckInsuranceConsts.ERROR_ENCOUNTERED,
      ]),
      timeout: delay(TIMEOUT),
    }),
    race({
      success: take(getUserDocumentsConsts.SUCCEED),
    }),
  ]);

  yield put(getPatientInsurancesListActions.send({ userId }));

  yield take(getPatientInsurancesListConsts.SUCCEED);

  yield put(manageInsurancesActions.setInsuranceRelatedDataFetching(false));
}

export function* downloadPatientInsuranceData() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_PATIENT_INSURANCES_DATA,
    downloadPatientInsuranceDataWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/download-patient-insurances-data.js